<template>
  <div class="Aboutus">
    <div class="bigImg">
        <img class="topimg" src="../../static/wap/index/top.png" alt="" />
      <div class="title">稳健金企</div>
      <div class="title">焕发新生</div>
      <div class="titles">香港黄金交易所AA类行员</div>
      <img class="download" @click="toLoad" src="../../static/wap/index/download.png" alt="" />
        
    </div>
    <div class="iconBox">
        <div class="indexTitle">香港黄金交易所</div>
        <div class="indexTitle"><span>AA类</span>行员</div>
      <div class="indexTitle1 part-tit">金融牌照编号 ：NO.081</div>
      <img src="../../static/wap/aboutus/cup.png" alt="">
    </div>
    <div class="contentBox">
      <div class="letterBox">
        <div class="lbSmallBox">
          
          <div>
            <span>RED LION CAPITAL，简称RLC，</span>是我们为大众投资者倾心打造的独立品牌，旨在向客户提供低点差和低利率的交易产品，让客户的投资物超所值，没有后顾之忧。公司依照全球最受欢迎的交易方式，专注为客户提供安全、稳定、高效的一站式交易服务。自品牌成立以来，红狮集团一直秉承“客户至上，诚信为本”的经营理念，致力于高科技智能化交易平台的建设，专业、专注、规范操作让红狮集团赢得了客户的高度信赖，同时也得到了业界的广泛关注和大力支持。
          </div>
           <div>
            <span>红狮集团</span>还为客户提供全面的资讯服务，独到的行情走势分析，重要经济播报和专业在线咨询等，全方位满足投资者的需求。公司采用全球领先的MT4交易平台，为投资者提供一站式现货投资服务。公司交易平台的稳定性更是备受市场赞誉，支持一秒平仓、EA智能交易，这些都对平台的稳定性有着高度的技术要求，而我们致力于超越行业技术标准。
          </div>
          <div>
            展望未来，红狮集团全体同仁将继续实践客户至上的经营理念，努力开拓创新，不断完善和提升产品服务，以帮助投资者实现梦想，共创美好生活。
          </div>
        </div>
        <img src="../../static/wap/aboutus/card1.png" alt="">
      </div>
      <div class="letterBox">
     
       
        <img src="../../static/wap/aboutus/card2.png" alt="">
      </div>
      <div class="letterBox">
     
       
        <img src="../../static/wap/aboutus/card3.png" alt="">
      </div>
      <div class="letterBox">
     
       
        <img src="../../static/wap/aboutus/card4.png" alt="">
      </div>
    </div>
  </div>
</template>
<script>
import eventBusMitter from '../../utils/eventbus'

  export default {
    name: 'Aboutus',
  metaInfo: {
    title: '关于红狮金业,现货黄金开户平台,伦敦金,伦敦银,安全持牌黄金交易平台',
    meta: [
      { name: 'keywords', content: '红狮金业,红狮启富,黄金交易平台,贵金属交易,贵金属投资,贵金属平台,现货黄金开户,正规靠谱外汇交易,正规网上交易平台' },
      { name: 'description', content: '红狮金业是专业值得信赖的国际投资交易平台,专注于为客户提供24小时全球金融产品在线交易,包括现货黄金、现货白银、贵金属等产品的开户、投资交易服务。' }
    ]
  },  
    data() {
      return{
        topData: [
        {
          name: "A",
          title: "市场01",
          title1: "45612.25 CNY",
          title2: "+ 0.01%",
        },
        {
          name: "B",
          title: "市场01",
          title1: "45612.25 CNY",
          title2: "+ 0.01%",
        },
        {
          name: "C",
          title: "市场01",
          title1: "45612.25 CNY",
          title2: "+ 0.01%",
        },
      ],
      sbldata:{
      
      },
      highLowData:{},
    
      }
    },
   
    created(){
      
      this.$emit('controlShow', false);
      eventBusMitter.emit('eventtab', { key: false })

   

    },
    mounted(){
      this.sbldata=this.$parent.sblsLiveData?this.$parent.sblsLiveData:'null';
    this.highLowData=this.$parent.sblsHighLowData?this.$parent.sblsHighLowData:'null'
  
    setTimeout(() => {
      console.log('shuju-------',this.sbldata['GOLD'])
    this.getNumber()

    }, 1000);
    },
    methods:{
         getNumber(){
  
    this.gold=this.getPrice('GOLD');
    this.sliver=this.getPrice('SILVER');
    this.usd=this.getPrice('XTIUSD')
    this.nas=this.getPrice('NAS100')
    this.hk50=this.getPrice('HK50')
  },
    // 价格浮动
      getPrice(type){
  if( this.sbldata[type]){
    let value=(this.sbldata[type].bidList[0].price-this.highLowData[type].priceclose).toFixed(2)
    let  symbol=value>0?'+':'-'
    let percentage = this.highLowData[type].priceclose? ((Math.abs(value) * 100) / this.highLowData[type].priceclose).toFixed(2) + '%': '0.00%';
    let obj={value,symbol,percentage}
    return obj

   }
        },
     toLoad(){
        eventBusMitter.emit('eventNas', {key:4})

        this.$router.push({
              name: "Appdownloadwap",
               query: {
                showTop:true
              }
            });
      },
    },
    computed: {
    //计算高度
    computeHeight() {
      let screenHeight = document.body.scrollTop;
      console.log(screenHeight);
      if (screenHeight > 415) {
        return "550px";
      } else {
        return "250px";
      }
    },
    golds(){
      return this.$parent.goldData
    },
    high(){
      return this.$parent.goldData1
    },

    priceRange(){
    let value=(this.golds-this.high).toFixed(2)
    let  symbol=value>0?'+':'-'
    let percentage = this.high? ((Math.abs(value) * 100) / this.high).toFixed(2) + '%': '0.00%';
      return    {value,symbol,percentage}
    },
     hk50(){
      return this.$parent.hk50
    },
    hk501(){
      return this.$parent.hk501
    },

    priceRange4(){
    let value=(this.hk50-this.hk501).toFixed(2)
    let  symbol=value>0?'+':'-'
    let percentage = this.hk501? ((Math.abs(value) * 100) / this.hk501).toFixed(2) + '%': '0.00%';
      return    {value,symbol,percentage}
    },
     nas(){
      return this.$parent.nas
    },
    nas1(){
      return this.$parent.nas1
    },

    priceRange3(){
    let value=(this.nas-this.nas1).toFixed(2)
    let  symbol=value>0?'+':'-'
    let percentage = this.nas1? ((Math.abs(value) * 100) / this.nas1).toFixed(2) + '%': '0.00%';
      return    {value,symbol,percentage}
    },
    sliver(){
      return this.$parent.sliver
    },
    sliver1(){
      return this.$parent.sliver1
    },

    priceRange1(){
    let value=(this.sliver-this.sliver1).toFixed(2)
    let  symbol=value>0?'+':'-'
    let percentage = this.sliver1? ((Math.abs(value) * 100) / this.sliver1).toFixed(2) + '%': '0.00%';
      return    {value,symbol,percentage}
    },
     usd(){
      return this.$parent.usd
    },
    usd1(){
      return this.$parent.usd1
    },

    priceRange2(){
    let value=(this.usd-this.usd1).toFixed(2)
    let  symbol=value>0?'+':'-'
    let percentage = this.usd1? ((Math.abs(value) * 100) / this.usd1).toFixed(2) + '%': '0.00%';
      return    {value,symbol,percentage}
    },
   
   
  },
  
  }
</script>

<style lang="less" scoped>
  .Aboutus{
    width: 100%;
    margin: 0 auto;
  
      .bigImg {
    width: 100%;
      height: 750px;
      background: url('../../static/wap/aboutus/topbg.png') no-repeat;
      background-size: cover;
    background-size: cover;
    box-sizing: border-box;
    //   overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    .title {
      font-size: 58px;
      line-height: 77px;
      color: #fff;
      font-weight: 700;
    }
    .titles {
      font-size: 14px;
      line-height: 20px;
      color: #fff;
      margin: 6px 0 24px 0;
    }
    .topimg {
      width: 110px;
      height: 30px;
      margin: 28px 0 6px 0;
    }
    .download {
      width: 180px;
      height: 34px;
    }
    .flex {
      display: flex;
      align-items: center;
    }
    .flex1 {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    //市场
     .topbox {
      width: 86%;
      height: 40px;
      overflow: scroll;
      display: flex;
      position: absolute;
      left: 1rem;
      bottom: -4%;
      z-index: 10;
      white-space: nowrap;
      .boxs {
        width: 164px;
        height: 40px;
        background: #fff;
        color: #fff;
        margin-right: 10px;
        padding: 10px 12px;
        box-sizing: border-box;
        .left {
          background: #1552ac;
          width: 26px;
          height: 26px;
          border-radius: 50%;
          font-size: 14px;
          line-height: 19px;
          margin-right: 7px
        }
        .right {
          font-size: 12px;
          line-height: 17px;
          .txt {
            font-size: 10px;
            color: #93939f;
            width: 36px;
          }
          .txts{
            color: #0F0F11;
            font-size: 12px;
            line-height: 17px;
            font-weight: 600;

          }
          .cont {
            display: flex;
            // flex-direction: column;
          }
        }
      }
    }
  }
   .indexTitle {
    font-size: 36px;
    line-height: 50px;
    color: #0f0f11;
    margin-top: 48px;
    span {
      color: #fa2314;
    }
    text-align: center;
  }
  .indexTitle1 {
    font-size: 14px;
    line-height: 20px;
    color: #0f0f11;
    margin: 6px 0 28px 0;
    span{
        font-weight: 700;
    }
  }
    .iconBox{
      width: 100%;
      margin: 0 auto;
      display: flex;
    //   justify-content: space-around;
    flex-direction: column;
      align-items: center;
      box-sizing: border-box;
      flex-wrap: wrap;
      box-sizing: border-box;
      padding: 48px 0 1.2rem;
      .indexTitle{
        margin: 0;
      }
    }
    .contentBox{
      width: 100%;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      padding-top: 20px;
      .letterBox{
        width: 95%;
        margin: 0 auto;
        margin-bottom: 1.15rem;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        position: relative;
        .xuxianBanner{
          position: absolute;
          top: -85px;
          left: -10px;
        }
        .lbSmallBox{
          width: 100%;
         
          div{
            width: 92%;
            margin: 0.5rem auto;
            font-size: 14px;
            color: #929292;
            line-height: 30px;
            // text-align: justify;
            span{
                color: #FA2314;
                font-weight: 600;

            }
          }
        }
        img{
          width: 92%;
          margin: 0 auto;
          height: auto;
        }
      }
    }
  }
</style>